import { GenericServicesGetVideosFromYoutubePlaylist } from "@services/GenericServices";

export default {
    data() {
        return {
            videos: [],
            playlistId: null,
            videoId: null,
        };
    },
    methods: {
        getVideosFromPlaylist() {
            this.videos = [];
            GenericServicesGetVideosFromYoutubePlaylist()
                .then((response) => {
                    let items = response.data.result;
                    if (items.length > 0) {
                        for (let i = 0; i < items.length; i++) {
                            this.videos.push({
                                playlistId: items[i].snippet.playlistId,
                                videoId: items[i].snippet.resourceId.videoId,
                                title: items[i].snippet.title.replace(
                                    "Tutoriais DataDrive ",
                                    ""
                                ),
                            });
                        }
                    }
                })
                .catch(console.log)
                .finally(() => {
                    this.$store.commit(
                        "tutorials/setTutorialsState",
                        this.videos
                    );
                });
        },
        getFirstVideoFromPlaylist() {
            GenericServicesGetVideosFromYoutubePlaylist(this.playlistId)
                .then((response) => {
                    let items = response.data.result;
                    if (items.length > 0) {
                        this.videoId = items[0].snippet.resourceId.videoId;
                    }
                })
                .catch(console.log);
        },
        redirectToPlaylist(videoId, playlistId) {
            window.open(
                `https://www.youtube.com/watch?v=${videoId}&list=${playlistId}`,
                "_blank"
            );
        },
    },
};
